export const getLoading = state => state.loading




// WEBPACK FOOTER //
// ./src/vuex/modules/network/getters.js